module.exports = __webpack_public_path__ + "img/Шымкент қ..08f44b8f.png";